import { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "../../@/components/ui/use-toast";
import { useVendorSignupMutation } from "../../api/api";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import BasicInformation from "./BasicInformation";
import BusinessAddressInformation from "./BusinessAddressInformation";
import StoreInformation from "./StoreInformation";
import SideImage from "../../components/SideImage";
import MyGoogleMap from "../../components/MyGoogleMap";
import { useJsApiLoader } from "@react-google-maps/api";
import ServiceTypeDropdown from "../../screens/AdminConfigurationPage/ServiceTypeDropDown";
import DisplaybussinessAddress from "./DisplaybussinessAddress";
import { isMobileScreen } from "../../lib/utils";
interface FormData {
  firstName: string;
  lastName: string;
  company: string;
  website: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
  address: string;
  cityName: string;
  state: string;
  zipCode: string;
  numberOfStores: string;
  soucreOfInformation: string;
  latitude: number;
  longitude: number;
}

interface LocationDetails {
  address: string;
  cityName: string;
  state: string;
  zipCode: string;
  lat: number;
  lng: number;
}

const libraries: any = ["places"];
const MOBILE_BREAKPOINT = 769;

const SignUpPage: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    clearErrors,
  } = useForm<any>();
  const [step, setStep] = useState(1);
  const [signupApi, { isLoading }] = useVendorSignupMutation();
  const { toast } = useToast();
  const navigate = useNavigate();

  const [selectedCode, setSelectedCode] = useState("+1");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [infoSource, setInfoSource] = useState("");
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [selectedServiceTypeId, setSelectedServiceTypeId] = useState<number>(0);
  const [addressInfo, setAddressInfo] = useState({
    address: "",
    cityName: "",
    state: "",
    zipCode: "",
    latitude: 0,
    longitude: 0,
  });
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth < MOBILE_BREAKPOINT
  );

  const handleOnLocationSelect = (details: LocationDetails) => {
    setValue("address", details.address);
    setValue("cityName", details.cityName);
    setValue("state", details.state);
    setValue("zipCode", details.zipCode);
    setValue("latitude", details.lat);
    setValue("longitude", details.lng);

    setAddressInfo({
      address: details.address,
      cityName: details.cityName,
      state: details.state,
      zipCode: details.zipCode,
      latitude: details.lat,
      longitude: details.lng,
    });
  };

  const handleAddressInputChange = (field: string, value: string) => {
    setAddressInfo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const validateStep = async (currentStep: number) => {
    let fieldsToValidate: string[] = [];
    switch (currentStep) {
      case 1:
        const passwordField = document.getElementById(
          "password"
        ) as HTMLInputElement;
        const confirmPasswordField = document.getElementById(
          "confirmPassword"
        ) as HTMLInputElement;
        if (passwordField?.value) setValue("password", passwordField?.value);
        if (confirmPasswordField?.value)
          setValue("confirmPassword", confirmPasswordField?.value);
        fieldsToValidate = [
          "firstName",
          "lastName",
          "company",
          "website",
          "email",
          "phone",
          "password",
          "confirmPassword",
        ];
        break;
      case 2:
        fieldsToValidate = ["address", "cityName", "state", "zipCode"];
        break;
      case 3:
        fieldsToValidate = ["numberOfStores", "soucreOfInformation"];
        break;
    }
    return await trigger(fieldsToValidate);
  };

  // const validateValues = () => {
  //   document.getElementById("password")
  //   document.getElementById("confirmPassword")
  // }

  const nextStep = async () => {
    let isStepValid = await validateStep(step);
    if (isStepValid) {
      setStep(step + 1);
    } else {
    }
  };
  const prevStep = () => {
    setStep(step - 1);
  };

  const handlePhoneChange = (code: string, number: string) => {
    setSelectedCode(code);
    setPhoneNumber(number);
    setValue("phone", number);
  };

  const handleStateChange = (state: string) => {
    setSelectedState(state);
    setValue("state", state);
  };

  const handleSourceOfInfoChange = (infoSource: string) => {
    setValue("soucreOfInformation", infoSource);
    setInfoSource(infoSource);
  };

  const handleServiceTypeChange = (serviceTypeId: number) => {
    setSelectedServiceTypeId(serviceTypeId);
    setValue("serviceTypeId", serviceTypeId);
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyA70RDovtCyeZisoqgzrpB4_hQ4_cQTOes",
    libraries: libraries,
    region: "ca",
    language: "en",
  });

  const geocodeLatLng = (lat: number, lng: number) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
        const addressComponents = results[0].address_components;
        const address = results[0].formatted_address;
        const cityName =
          addressComponents.find((c) => c.types.includes("locality"))
            ?.long_name || "";
        const state =
          addressComponents.find((c) =>
            c.types.includes("administrative_area_level_1")
          )?.long_name || "";
        const zipCode =
          addressComponents.find((c) => c.types.includes("postal_code"))
            ?.long_name || "";

        handleOnLocationSelect({
          lat,
          lng,
          address,
          cityName,
          state,
          zipCode,
        });
      } else {
        console.error(
          "Geocode was not successful for the following reason:",
          status
        );
      }
    });
  };

  const onSubmit: SubmitHandler<FormData> = async (data) => {
    try {
      if (selectedServiceTypeId <= 0) {
        toast({
          title: "Error",
          description: "Invalid service type",
        });
        return;
      }

      const storeInfo = {
        numberOfStores: parseInt(data.numberOfStores),
      };

      const { confirmPassword, ...basicInfoWithoutConfirmPassword } = data;

      const combineData = {
        ...basicInfoWithoutConfirmPassword,
        countryCode: data.phone !== undefined ? selectedCode : "",
        address: data.address,
        cityName: data.cityName,
        state: data.state,
        zipCode: data.zipCode,
        latitude: data.latitude,
        longitude: data.longitude,
        ...storeInfo,
        serviceTypeId: selectedServiceTypeId,
      };
      console.log("Combine: ", combineData);
      const response = await signupApi({
        vendorSignupDto: {
          ...combineData,
          serviceTypeId: selectedServiceTypeId,
        },
      }).unwrap();
      if (response?.message.includes("success")) {
        navigate("/signup-success");
      }
    } catch (error: any) {
      if (error.data === undefined) {
        toast({
          title: "Error",
          description: "Something went wrong",
        });
      } else {
        toast({
          title: "Error",
          description: `${error.data.message}`,
        });
      }
    }
  };

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setValue("latitude", latitude);
        setValue("longitude", longitude);
        setLatitude(latitude);
        setLongitude(longitude);
        geocodeLatLng(latitude, longitude);
      },
      (error) => {
        console.error("Error getting current location:", error);
      }
    );
  };

  useEffect(() => {
    if (step === 2 && isLoaded) {
      getCurrentLocation();
    }
  }, [step, isLoaded]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isAddressFormValid = () => {
    return (
      addressInfo.address &&
      addressInfo.cityName &&
      addressInfo.state &&
      addressInfo.zipCode &&
      Boolean(addressInfo.latitude) &&
      Boolean(addressInfo.longitude)
    );
  };

  return (
    <div className="flex h-screen select-none flex-col md:flex-row bg-white overflow-y-auto">
      <div className="lg:w-1/2 bg-white xxl:px-[132px] xl:px-24 px-10 xxxl:py-10 xl:py-6 py-4 flex-1 lg:min-h-screen">
        <form
          onSubmit={handleSubmit(onSubmit)}
          autoComplete="new-password"
          className="pb-20"
        >
          <div className="text-start mb-8">
            <img
              src="/Images/LoginPageImages/Auth-Page-Logo.png"
              alt="Auth-Page-Logo"
              className="w-36 mt-10 font-bold mb-3"
            />
            <h1 className="xxxl:text-5xl text-2xl mt-10 text-black font-helveticaBold">
              Start Your Journey as a Vendor
            </h1>
            <p className="text-balance xxl:text-base xl:text-sm text-xs font-normal text-customGrayBase mt-2 xxxl:mb-16 xxl:mb-8 xl:mb-4">
              Create your Afrocart account to easily manage your store, add
              products, track sales, and connect with customers. This form is
              for retailers only.
            </p>
          </div>

          {step === 1 && (
            <BasicInformation
              register={register}
              setSelectedCode={setSelectedCode}
              selectedCode={selectedCode}
              phoneNumber={phoneNumber}
              onPhoneChange={handlePhoneChange}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              getValues={getValues}
            />
          )}

          {step === 2 && (
            <div
              className={`${isMobile ? "block md:hidden" : "hidden md:block"}`}
            >
              {isMobile ? (
                <div className="mb-4">
                  <DisplaybussinessAddress
                    address={addressInfo.address}
                    cityName={addressInfo.cityName}
                    state={addressInfo.state}
                    zipCode={addressInfo.zipCode}
                    latitude={addressInfo.latitude}
                    longitude={addressInfo.longitude}
                  />
                  <BusinessAddressInformation
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    onStateChange={handleStateChange}
                    clearErrors={clearErrors}
                    selectedState={selectedState}
                    hideAddress={true}
                    onInputChange={handleAddressInputChange}
                    addressInfo={addressInfo}
                  />
                </div>
              ) : (
                <DisplaybussinessAddress
                  address={addressInfo.address}
                  cityName={addressInfo.cityName}
                  state={addressInfo.state}
                  zipCode={addressInfo.zipCode}
                  latitude={addressInfo.latitude}
                  longitude={addressInfo.longitude}
                />
              )}
            </div>
          )}

          {step === 3 && (
            <StoreInformation
              register={register}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              onSourceOfInfoChange={handleSourceOfInfoChange}
              onServiceTypeChange={handleServiceTypeChange}
              sourceOfInfo={infoSource}
              ServiceTypeDropdownComponent={
                <ServiceTypeDropdown
                  selectedServiceType={selectedServiceTypeId.toString()}
                  onChange={(value) => handleServiceTypeChange(parseInt(value))}
                  placeholder="Please select"
                />
              }
            />
          )}
          {step === 1 ? (
            <div className="mt-6 grid md:grid-cols-2 grid-cols-1">
              <div className="col-span-1 mr-2 justify-items-end">
                <button
                  type="button"
                  onClick={nextStep}
                  className="flex gap-3 items-center justify-center w-full py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-customGreenColor hover:bg-customGreenColor focus:outline-none"
                >
                  {" "}
                  Next
                  <FaArrowRight />
                </button>
              </div>
            </div>
          ) : step === 2 ? (
            <div className="mt-6 grid md:grid-cols-2 grid-cols-1">
              <div className="flex flex-col md:flex-row col-span-1 xxxl:mt-[1.25rem] mt-[1.25rem] mr-2 gap-4">
                <button
                  type="button"
                  onClick={prevStep}
                  className="col-span-1 w-full flex items-center justify-center py-3 px-4 bg-transparent border border-customBorderColor text-customGrayBase rounded-lg hover:bg-gray-100"
                >
                  <FaArrowLeft className="text-sm mr-1 flex-shrink-0" />
                  Previous
                </button>
                <button
                  type="button"
                  onClick={nextStep}
                  disabled={!isAddressFormValid()}
                  className={`col-span-1 w-full flex items-center justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white ${
                    isAddressFormValid()
                      ? "bg-customGreenColor focus:outline-none"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
                >
                  Next
                  <FaArrowRight className="text-sm ml-1 flex-shrink-0" />
                </button>
              </div>
            </div>
          ) : step === 3 ? (
            <div className="mt-6 grid md:grid-cols-2 grid-cols-1">
              <div className="grid grid-cols-1 gap-4 justify-items-end xxxl:mt-[1.25rem] mt-[1.25rem] mr-2 col-span-1">
                <button
                  type="submit"
                  className="col-span-1 w-full flex items-center justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-customGreenColor focus:outline-none"
                >
                  {isLoading && (
                    <div className="border-white h-3 w-3 animate-spin rounded-full border-2 border-t-customGreenColor cursor-not-allowed opacity-50" />
                  )}
                  {isLoading ? "Signing up..." : "Sign Up"}
                  {!isLoading && (
                    <FaArrowRight className="text-sm align-middle ml-1 flex-shrink-0" />
                  )}
                </button>
                <button
                  type="button"
                  onClick={prevStep}
                  className="col-span-1 w-full flex items-center justify-center py-3 px-4 bg-transparent border border-customBorderColor text-customGrayBase rounded-lg hover:bg-gray-100"
                >
                  <FaArrowLeft className="text-sm mr-1 flex-shrink-0" />
                  Previous
                </button>
              </div>
            </div>
          ) : (
            <></>
          )}

          {step !== 3 && (
            <p className="text-start text-customGrayBase mt-[4%] pb-4">
              Already have an account?{" "}
              <Link
                to="/vendor-login"
                className="font-helveticaMedium text-customGreenColor"
              >
                Sign in
              </Link>
            </p>
          )}
        </form>
      </div>
      <div
        className={`sticky top-0 w-full md:w-1/2 ${
          isMobile ? "hidden" : "md:flex"
        } items-center justify-center bg-white p-6 pt-4 lg:min-h-screen`}
      >
        {step === 2 ? (
          <div className="w-full flex flex-col items-center justify-center bg-customBgGray h-full border rounded-lg">
            <div className="w-full h-full rounded-lg px-10 flex flex-col items-center justify-center">
              <div className="w-full">
                <MyGoogleMap
                  key={latitude}
                  onLocationSelect={handleOnLocationSelect}
                  initialLocation={{
                    lat: latitude,
                    lng: longitude,
                  }}
                />
              </div>
              <div className="w-full">
                <BusinessAddressInformation
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  onStateChange={handleStateChange}
                  clearErrors={clearErrors}
                  selectedState={selectedState}
                  hideAddress={true}
                  onInputChange={handleAddressInputChange}
                  addressInfo={addressInfo}
                />
              </div>
            </div>
          </div>
        ) : (
          <SideImage />
        )}
      </div>
    </div>
  );
};

export default SignUpPage;
